<template>
  <div id="cup_scheduleDetail_analysis">
    <MoreThemeList
      v-if="findAnalysisItemParams"
      :axiosBaseUrl="axiosBaseUrl"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :isRefresh="isRefresh"
      :refreshTime="refreshTime"
      :findAnalysisItemParams="findAnalysisItemParams"
      :curTimeZoneItem="curTimeZoneItem"
    ></MoreThemeList>
  </div>
</template>

<script>
// 需要后端修改下拉选择框，需要补齐did|eid|pid|字段才能使用
import MoreThemeList from '@components/base/theme/more_themeList.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'cup_scheduleDetail_analysis',
  mixins: [cup_base_data_mixin],
  components: {
    MoreThemeList,
  },
  props: {
    isRefresh: {
      type: Boolean,
      default: false,
    },
    refreshTime: {
      type: Number,
      default: 15 * 1000, //刷新时间 单位毫秒
    },
  },
  data() {
    return {
      themeTemplateType: 3,
      findAnalysisItemParams: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const query = this.$route.query
      this.cid = query.cid
      this.sid = query.sid
      this.mid = query.mid
      await this.makeAnalysisItemParams()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams() {
      // 每个页面单独设置不同函数
      // 因为只有比赛，所以 https_package_selectApi 不需要传did,eid,pid这些
      this.findAnalysisItemParams = {
        sportType: 'football',
        templateType: this.themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: this.mid,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_scheduleDetail_analysis {
  padding-top: 1.388vw;
  width: 100%;
}
</style>
